import { useQuery } from '@tanstack/react-query';
import { getAutomationLimit } from '@/services/dmAutomation.service';
import { queryKeys } from '@/hooks/queries/keys';

/** 자동화 상한/잔여만 가볍게 조회(목록 미포함). 사이드바 "새 자동화 만들기" 게이팅용. */
export const useAutomationLimit = (options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: queryKeys.dmAutomation.limit(),
        queryFn: getAutomationLimit,
        enabled: options?.enabled ?? true,
    });
};
